import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=a4043682&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4043682')) {
      api.createRecord('a4043682', component.options)
    } else {
      api.reload('a4043682', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=a4043682&", function () {
      api.rerender('a4043682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aLBJLH68LJXx/JS/imageCarousel.vue"
export default component.exports